export default {
  container: {
    maxWidth: "1256px",
    padding: "15px"
  }
};
